import { Action, ActionReducer } from '@ngrx/store';
import { fromJS } from 'immutable';
import { AppState, AppStateRecord } from 'src/app';
import { makeTypedFactory } from 'typed-immutable-record';
import {
  CONTRACTSCOM_ACTION_TYPES,
  ContractsReceived,
} from './actions/contracts-com.action';
import { FundActionTypes, FundsActionsUnion } from './actions/funds.actions';
import {
  OperationPuppetActionsUnion,
  OperationPuppetTypes,
} from './actions/operation-puppet.actions';

export interface ActionWithPayload extends Action {
  type: string;
  payload: any;
}

// Application
export const BOOTSTRAP_SESSION = 'BOOTSTRAP_SESSION';
export const SOLACE_INITIALIZER = 'SOLACE_INITIALIZER';
export const CENTRAL_HOUR_INITIALIZER = 'CENTRAL_HOUR_INITIALIZER';
export const IVA_INITIALIZER = 'IVA_INITIALIZER';
export const MARKET_OPERATION_TIME_INITIALIZER =
  'MARKET_OPERATION_TIME_INITIALIZER';
export const CONTRACTS_INITIALIZER = 'CONTRACTS_INITIALIZER';
export const USA_MARKET_INITIALIZER = 'USA_MARKET_INITIALIZER';

// Configurations
export const CONFIG = 'CONFIG';
export const HOST_IP = 'HOST_IP';

// Session
export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';

// User
export const SET_USER_CONFIG = 'SET_USER_CONFIG';
export const SET_USER_PRIVACY = 'SET_USER_PRIVACY';
// Params
export const CENTRAL_HOUR = 'CENTRAL_HOUR';
export const IVA = 'IVA';

// Market
export const MARKET_OPERATION_TIME = 'MARKET_OPERATION_TIME';

// Contracts
export const CONTRACTS = 'CONTRACTS';
export const CURRENT_CONTRACT = 'CURRENT_CONTRACT';
export const CURRENT_CONTRACT_PROPERTIES = 'CURRENT_CONTRACT_PROPERTIES';
export const CURRENT_CONTRACT_TOTALS = 'CURRENT_CONTRACT_TOTALS';
export const CURRENT_CONTRACT_CONTRACTID = 'CURRENT_CONTRACT_CONTRACTID';
export const CURRENT_CONTRACT_LOREM_ACCOUNT = 'CURRENT_CONTRACT_LOREM_ACCOUNT';
export const CURRENT_CONTRACT_LOREM_ACCOUNT_MIGRATED =
  'CURRENT_CONTRACT_LOREM_ACCOUNT_MIGRATED';
// Position
export const POSITION = 'POSITION';
export const POSITION_IS_PROCESSING = 'POSITION_IS_PROCESSING';

// Portfolio
export const PORTFOLIO = 'PORTFOLIO';
export const TIME_WEIGHTED_RETURN = 'TIME_WEIGHTED_RETURN';
export const UPDATE_INITIAL_DATE = 'UPDATE_INITIAL_DATE';
export const UPDATE_FINAL_DATE = 'UPDATE_FINAL_DATE';
export const POSITION_TYPE = 'POSITION_TYPE';
export const POSITION_COLUMNS = 'POSITION_COLUMNS';
export const POSITION_USE_SOLACE_CONNECTION = 'POSITION_USE_SOLACE_CONNECTION';

// Search
export const CURRENT_SYMBOL = 'CURRENT_SYMBOL';
export const LAST_SYMBOL_SEARCHED = 'LAST_SYMBOL_SEARCHED';

// Blotter
export const BLOTTER_CAPITALS = 'BLOTTER_CAPITALS';
export const BLOTTER_FUNDS = 'BLOTTER_FUNDS';
export const BLOTTER_CASH = 'BLOTTER_CASH';
export const BLOTTER_FILTER = 'BLOTTER_FILTER';
export const BLOTTER_UPDATE = 'BLOTTER_UPDATE';

export const BLOTTER_CANCELREPLACE = 'BLOTTER_CANCELREPLACE';
export const BLOTTER_ISSUE = 'BLOTTER_ISSUE';

// Operation
export const OPERATION_RESET = 'OPERATION_RESET';
export const OPERATION_HARD_RESET = 'OPERATION_HARD_RESET';
export const OPERATION_PRICE = 'OPERATION_PRICE';
export const OPERATION_CLEAR_TEXT = 'OPERATION_CLEAR_TEXT';
export const OPERATION_MODAL_OPENED = 'OPERATION_MODAL_OPENED';

// Solace
export const SOLACE_TOPICS = 'SOLACE_TOPICS';

// Watchlist
export const WATCHLIST_DELETE = 'WATCHLIST_DELETE';
export const REMOVE_FROM_WATCHLIST = 'REMOVE_FROM_WATCHLIST';
export const WATCHLIST_RESTART = 'WATCHLIST_RESTART';
export const WATCHLIST_NEW_ISSUE = 'WATCHLIST_NEW_ISSUE';

// BIG SCREEN IN OPERATION
export const BIG_SCREEN = 'BIG_SCREEN';

// DOM MANIPULATIONS
export const NO_SCROLL = 'NO_SCROLL';

// USER ROLES
export const CURRENT_USER_ROLE = 'CURRENT_USER_ROLE';
export const CURRENT_USER_GLOBAL = 'CURRENT_USER_GLOBAL';

// EL PATRON
export const EL_PATRON_LOGOUT = 'EL_PATRON_LOGOUT';
export const EL_PATRON_INIT = 'EL_PATRON_INIT';
export const EMPTY_CONTRACTS = 'EMPTY_CONTRACTS';
export const GOT_FROM_STORAGE = 'GOT_FROM_STORAGE';
export const EL_PATRON_SHOW_IFRAME = 'EL_PATRON_SHOW_IFRAME';
export const EL_PATRON_DEFAULT_CONTRACT = 'EL_PATRON_DEFAULT_CONTRACT';

// UJET
export const UJET = 'UJET';

// STATUS CARD
export const NUMBER_CARD = 'NUMBER_CARD';
export const STATUS_VERIFICATION_CARD = 'STATUS_VERIFICATION_CARD';
export const USER_HAS_NO_BANK_ACCOUNT = 'USER_HAS_NO_BANK_ACCOUNT';

// PARTYID
export const PARTY_ID = 'PARTY_ID';

// LOREM
export const LOREM = 'LOREM';
export const LOREM_ACCOUNTS = 'LOREM_ACCOUNTS';

// TREASURY

// FEATURE_FLAGS
export const INIT_ROLLOUT = 'INIT_ROLLOUT';
export const FEATURE_FLAGS = 'FEATURE_FLAGS';
export const SERVICE_INTERRUPTION = 'SERVICE_INTERRUPTION';

export const BANK_LIST = 'BANK_LIST';
export const DW_ACCOUNT_STATUS = 'DW_ACCOUNT_STATUS';

// PRICE_ALERTS
export const OPEN_PRICE_ALERTS = 'OPEN_PRICE_ALERTS';
export const DAY_TRADES = 'DAY_TRADES';

// COACHMARKS
export const COACHMARK = 'COACHMARK';

//Opening
export const OPENING = 'OPENING';

export class AppReducer {
  static appState: any = {};

  static initialState: AppState = {
    initializers: fromJS({
      centralHour: false,
      solace: false,
      contracts: false,
      IVA: false,
      marketOperationTime: false,
      usaMarket: false,
    }),
    marketOperationTime: fromJS({}),
    params: fromJS({
      centralHour: '',
      IVA: 0,
    }),
    bootstrapSession: false,
    loggedIn: false,
    loggedInUser: fromJS({}),
    config: {},
    hostClient: {},
    solace_topics: fromJS([]),
    contracts: fromJS([]),
    currentContract: fromJS({}),
    portfolio: fromJS({
      timeWeightedReturn: fromJS({}),
      initialDate: fromJS({}),
      finalDate: fromJS({}),
      positionType: fromJS({}),
      positionColumns: fromJS({}),
      positionUseSolaceConnection: false,
    }),
    position: fromJS([]),
    processingPosition: false,
    currentSymbol: fromJS({}),
    triggerCancelReplace: fromJS([]),
    blotter: fromJS({
      filter: fromJS({}),
      capitals: fromJS([]),
      funds: fromJS([]),
      cash: fromJS([]),
      issue: {},
    }),
    dayTrades: fromJS({}),
    operation: fromJS([]),
    watchlists: fromJS({
      toDelete: fromJS({}),
      toLiveDelete: '',
      newIssue: fromJS({}),
    }),
    triggerWatchlistAction: fromJS([]),
    isBigScreen: false,
    scrollBlocked: false,
    userRole: undefined,
    userGlobal: undefined,
    currentFund: undefined,
    elPatron: fromJS({
      logout: false,
      refreshedToken: '',
      showIframe: false,
      defaultContract: undefined,
    }),
    emptyContracts: undefined,
    elPatronData: fromJS({}),
    ujet: {},
    gotFromStrage: false,
    statusCard: fromJS({
      numberCard: undefined,
      statusVerificationCard: undefined,
    }),
    partyId: undefined,
    lorem: fromJS({
      apiLorem: undefined,
    }),
    userHasBankAccount: undefined,
    changedContract: undefined,
    serviceInterruption: undefined,
    initRollout: undefined,
    loremAccounts: fromJS({
      data: [],
      loaded: false,
    }),
    funds: fromJS({
      loaded: false,
      loading: false,
      data: {},
    }),
    puppet: fromJS({
      selectedTab: 0,
    }),
    bankList: fromJS([]),
    contractAccountsCollection: fromJS({
      loaded: false,
      loading: false,
      data: {},
    }),
    openPriceAlerts: false,
    coachmarkToursVisited: fromJS([]),
    dwAccountStatus: undefined,
    opening: fromJS({
      openingType: undefined,
    }),
    featureFlags: undefined,
  };

  static appStateFactory: any = makeTypedFactory<AppState, AppStateRecord>(
    AppReducer.initialState,
  );

  static getReducer(
    state: any,
    action: ActionWithPayload | FundsActionsUnion | OperationPuppetActionsUnion,
  ): ActionReducer<AppStateRecord> {
    if (!state || !state.initializers) {
      state = AppReducer.appStateFactory(AppReducer.initialState);
    }

    switch (action.type) {
      // App reducers
      case CENTRAL_HOUR_INITIALIZER:
        return state.mergeDeep({
          initializers: { centralHour: action.payload },
        });
      case IVA_INITIALIZER:
        return state.mergeDeep({ initializers: { IVA: action.payload } });
      case SOLACE_INITIALIZER:
        return state.mergeDeep({ initializers: { solace: action.payload } });
      case USA_MARKET_INITIALIZER:
        return state.mergeDeep({
          initializers: { usaMarket: action.payload },
        });
      case MARKET_OPERATION_TIME_INITIALIZER:
        return state.mergeDeep({
          initializers: { marketOperationTime: action.payload },
        });
      case CONTRACTS_INITIALIZER:
        return state.mergeDeep({ initializers: { contracts: action.payload } });

      case BOOTSTRAP_SESSION:
        return state.merge({ bootstrapSession: action.payload });

      // Configuration settings reducers
      case CONFIG:
        return state.merge({ config: action.payload });
      case HOST_IP:
        return state.merge({ hostClient: { value: action.payload } });

      // Session reducers
      case LOGIN_USER:
        return state.mergeDeep({
          loggedInUser: action.payload,
          loggedIn: true,
        });
      case SET_USER_CONFIG:
        return state.mergeDeep({
          loggedInUser: {
            config: {
              columns: action.payload,
            },
          },
        });
      case SET_USER_PRIVACY:
        return state.mergeDeep({
          loggedInUser: {
            privacy: action.payload,
          },
        });
      // Params
      case CENTRAL_HOUR:
        return state.mergeDeep({ params: { centralHour: action.payload } });
      case IVA:
        return state.mergeDeep({ params: { IVA: action.payload } });

      // Market
      case MARKET_OPERATION_TIME:
        return state.merge({ marketOperationTime: action.payload });

      // Contracts
      case CONTRACTS:
        return state.merge({ contracts: action.payload });
      case CURRENT_CONTRACT:
        return state.merge({ currentContract: action.payload });
      case CURRENT_CONTRACT_PROPERTIES:
        return state.mergeDeep({
          currentContract: { properties: action.payload },
        });
      case CURRENT_CONTRACT_LOREM_ACCOUNT:
        return state.mergeDeep({
          currentContract: {
            isLoremAccount: action.payload,
            loremAccountLoaded: true,
          },
        });
      case CURRENT_CONTRACT_LOREM_ACCOUNT_MIGRATED:
        return state.mergeDeep({
          currentContract: { isLoremAccountMigrated: action.payload },
        });
      case CURRENT_CONTRACT_TOTALS:
        return state.mergeDeep({ currentContract: { totals: action.payload } });
      case CURRENT_CONTRACT_CONTRACTID:
        return state.merge({ changedContract: { contractID: action.payload } });

      // Portfolio
      case PORTFOLIO:
        return state.merge({ portfolio: action.payload });
      case TIME_WEIGHTED_RETURN:
        return state.mergeDeep({
          portfolio: { timeWeightedReturn: action.payload },
        });
      case UPDATE_INITIAL_DATE:
        return state.mergeDeep({ portfolio: { initialDate: action.payload } });
      case UPDATE_FINAL_DATE:
        return state.mergeDeep({ portfolio: { finalDate: action.payload } });
      case POSITION_TYPE:
        return state.mergeDeep({ portfolio: { positionType: action.payload } });
      case POSITION_COLUMNS:
        return state.mergeDeep({
          portfolio: { positionColumns: action.payload },
        });
      case POSITION_USE_SOLACE_CONNECTION:
        return state.mergeDeep({
          portfolio: { positionUseSolaceConnection: action.payload },
        });

      // Position
      case POSITION:
        return state.merge({ position: action.payload });
      case POSITION_IS_PROCESSING:
        return state.merge({ processingPosition: action.payload });

      // Blotter
      case BLOTTER_CAPITALS:
        return state.merge({ blotter: { capitals: action.payload } });
      case BLOTTER_FUNDS:
        return state.merge({ blotter: { funds: action.payload } });
      case BLOTTER_CASH:
        return state.mergeDeep({ blotter: { cash: action.payload } });
      case BLOTTER_FILTER:
        return state.mergeDeep({ blotter: { filter: action.payload } });
      case BLOTTER_ISSUE:
        return state.mergeDeep({ blotter: { issue: action.payload } });

      case BLOTTER_UPDATE:
        return state.mergeDeep({ blotter: { update: action.payload } });

      case BLOTTER_CANCELREPLACE:
        return state.merge({ triggerCancelReplace: action.payload });
      // Search
      case CURRENT_SYMBOL:
        return state.merge({ currentSymbol: action.payload });
      // Operation
      case OPERATION_RESET:
        return state.merge({ operation: action.payload });
      case OPERATION_HARD_RESET:
        return state.merge({ operation: action.payload });
      case OPERATION_PRICE:
        return state.merge({ operation: action.payload });
      case OPERATION_CLEAR_TEXT:
        return state.merge({ operation: action.payload });
      case OPERATION_MODAL_OPENED:
        return state.merge({ operation: action.payload });
      // Solace reducers
      case SOLACE_TOPICS:
        return state.merge({ solace_topics: action.payload });

      case DAY_TRADES:
        return state.mergeDeep({ dayTrades: action.payload });

      case LOGOUT_USER:
        const currentState: any = state;

        return currentState.merge({
          loggedIn: false,
          loggedInUser: fromJS({}),
          solace_topics: fromJS([]),
          marketOperationTime: fromJS({}),
          contracts: fromJS([]),
          currentContract: fromJS({}),
          portfolio: fromJS({
            timeWeightedReturn: fromJS({}),
            initialDate: fromJS({}),
            finalDate: fromJS({}),
            positionType: fromJS({}),
            positionColumns: fromJS({}),
          }),
          position: fromJS([]),
          currentSymbol: fromJS({}),
          triggerCancelReplace: fromJS([]),
          blotter: fromJS({
            filter: fromJS({}),
            capitals: fromJS([]),
            funds: fromJS([]),
            cash: fromJS([]),
            issue: fromJS({}),
          }),
          initializers: fromJS({
            centralHour: false,
            solace: false,
            contracts: false,
            IVA: false,
            marketOperationTime: false,
          }),
          params: fromJS({
            centralHour: '',
            IVA: 0,
          }),
          bootstrapSession: false,
          processingPosition: false,
          operation: fromJS([]),
          currentFund: undefined,
          elPatron: fromJS({
            logout: false,
            refreshedToken: '',
            showIframe: false,
            defaultContract: undefined,
          }),
          emptyContracts: undefined,
          elPatronData: fromJS({}),
          ujet: {},
          gotFromStrage: false,
          statusCard: fromJS({
            numberCard: undefined,
            statusVerificationCard: undefined,
          }),
          partyId: undefined,
          lorem: fromJS({
            apiLorem: undefined,
          }),
          userHasBankAccount: undefined,
          changedContract: undefined,
          initRollout: undefined,
          loremAccounts: fromJS({
            data: [],
            loaded: false,
          }),
          bankList: fromJS([]),
          dayTrades: fromJS({}),
        });
      case WATCHLIST_DELETE:
        return state.merge({
          watchlists: {
            toDelete: action.payload,
          },
        });
      case REMOVE_FROM_WATCHLIST:
        return state.merge({
          watchlists: {
            toLiveDelete: action.payload,
          },
        });
      case WATCHLIST_RESTART:
        return state.merge({
          watchlists: {
            toDelete: {},
            toLiveDelete: '',
            newIssue: {},
          },
        });
      case WATCHLIST_NEW_ISSUE:
        return state.merge({
          watchlists: {
            newIssue: action.payload,
          },
        });
      // BIG SCREEN IN OPERATION
      case BIG_SCREEN:
        return state.merge({
          isBigScreen: action.payload,
        });
      // DOM MANIPULATIONS
      case NO_SCROLL:
        return state.merge({
          scrollBlocked: action.payload,
        });
      // USER ROLES
      case CURRENT_USER_ROLE:
        return state.merge({
          userRole: action.payload,
        });
      // USER GLOBAL
      case CURRENT_USER_GLOBAL:
        return state.merge({
          userGlobal: action.payload,
        });
      case FundActionTypes.SELECT_FUND:
        return state.merge({
          currentFund: action.payload,
        });
      case EL_PATRON_LOGOUT:
        return state.merge({
          elPatron: action.payload,
        });
      case EL_PATRON_INIT:
        return state.mergeDeep({
          elPatronData: action.payload,
        });
      case EMPTY_CONTRACTS:
        return state.merge({
          emptyContracts: action.payload,
        });
      // UJET CHAT
      case UJET:
        return state.merge({
          ujet: action.payload,
        });
      case GOT_FROM_STORAGE:
        return state.merge({
          gotFromStrage: action.payload,
        });
      // statusCard
      case NUMBER_CARD:
        return state.mergeDeep({
          statusCard: {
            numberCard: action.payload,
          },
        });

      case STATUS_VERIFICATION_CARD:
        return state.mergeDeep({
          statusCard: {
            statusVerificationCard: action.payload,
          },
        });

      case LOREM:
        return state.mergeDeep({
          Lorem: {
            apiLorem: action.payload,
          },
        });

      case PARTY_ID:
        return state.merge({
          partyId: action.payload,
        });

      case USER_HAS_NO_BANK_ACCOUNT:
        return state.mergeDeep({
          userHasBankAccount: action.payload,
        });
      case EL_PATRON_SHOW_IFRAME:
        return state.mergeDeep({
          elPatron: {
            showIframe: action.payload,
          },
        });
      case EL_PATRON_DEFAULT_CONTRACT:
        return state.mergeDeep({
          elPatron: {
            defaultContract: action.payload,
          },
        });
      case DW_ACCOUNT_STATUS:
        return state.mergeDeep({
          dwAccountStatus: action.payload,
        });

      case SERVICE_INTERRUPTION: {
        return state.mergeDeep({
          serviceInterruption: action.payload,
        });
      }
      case INIT_ROLLOUT:
        return state.mergeDeep({
          initRollout: action.payload,
        });
      case FEATURE_FLAGS:
        return state.mergeDeep({
          featureFlags: action.payload,
        });
      case LOREM_ACCOUNTS:
        return state.merge({
          loremAccounts: {
            data: action.payload,
            loaded: true,
          },
        });
      case FundActionTypes.REQUEST_FUNDS:
        return state.merge({
          funds: {
            loading: true,
            loaded: false,
            data: {},
          },
        });
      case FundActionTypes.FUNDS_RECEIVED:
        return state.merge({
          funds: {
            loading: false,
            loaded: true,
            data: action.payload,
          },
        });
      case OperationPuppetTypes.SELECT_TAB:
        return state.merge({
          puppet: {
            selectedTab: action.payload,
          },
        });
      case BANK_LIST:
        return state.merge({
          bankList: action.payload,
        });
      case CONTRACTSCOM_ACTION_TYPES.contracts_received:
        return state.merge({
          contractAccountsCollection: {
            loading: false,
            loaded: true,
            data: (action as ContractsReceived).payload,
          },
        });
      case OPEN_PRICE_ALERTS:
        return state.mergeDeep({
          openPriceAlerts: action.payload,
        });
      case COACHMARK:
        return state.mergeDeep({
          coachmarkToursVisited: action.payload,
        });
      case OPENING:
        return state.mergeDeep({
          opening: action.payload,
        });

      default:
        return state;
    }
  }
}
